import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rent-increase-calculator',
  component: () => import('../../routes/RentIncreaseCalculator.svelte'),
  card: {
    id: 'rent-increase-calculator',
    title: 'Rent Increase Calculator',
    description: 'Project your rent over time with annual increases. See how rent hikes affect your monthly costs and total housing expenses.',
    icon: 'home',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/rent-increase-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Rent Increase Calculator – Project Rent Hikes Over Time',
    description:
      'Free rent increase calculator to project your monthly rent and total housing costs over 1-30 years. Enter current rent, annual increase rate, and term to see future rent projections.',
  },
};

export default meta;
